import { Search } from 'lucide-react';

import { NodeShell } from './NodeShell';

interface EnrichDataNodeData {
  label: string;
  action?: string;
  outputVariable?: string;
}

export const EnrichDataNode = ({
  data,
  selected,
}: {
  data: EnrichDataNodeData;
  selected?: boolean;
}) => (
  <NodeShell
    type="enrich_data"
    icon={<Search size={16} />}
    label={data.label}
    subtitle={
      data.action
        ? `${data.action}${data.outputVariable ? ` → ${data.outputVariable}` : ''}`
        : undefined
    }
    selected={selected}
  />
);
